import { styled } from '@vw-marketing/us-components';

export const StyledTweetPlaceHolderContainer = styled.div`
  min-width: 250px;
  min-height: 460px;
  overflow-x: hidden;
  overflow-y: hidden;
  border: 1px solid rgb(204, 214, 221);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
